var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"creek-broadcast-page-container"}},[_c('creek-audio-player-page',{attrs:{"broadcast-id":_vm.$route.params.broadcastID}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }